import ContentsWrapperView from './contents_wrapper_view';

export default ContentsWrapperView;
